 <!-- Main Page Start -->
 <div class="content-wrapper ">
        <section class="chatSection">
          <div class="chat-body">  
              <div class="row">
                   <div class="col-12 col-lg-4">
                      <div class="bg-white borderrt" >
                          <div class="chat_heading" >
                          <h6 class="heading-6 m-0">Messages </h6>
                          </div>
                      
                        <div class="paddingside p-0 ">
                          <div class="scrollbar infinite-scroll" id="style-1" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
                            <ul class="userList">
                              <li class="" *ngFor="let data of allData let i=index">
                                <a  style="position: relative;" href="javascript:void(0);" class="jobinnerid" aria-expanded="false" routerLink="/message/message-detail/{{data.id}}">
                                    <div class="nav-label id">
                                      <span>{{data?.jobTitle}}: {{data.newId}}</span> 
                                      <div class="">{{data.createdAt | date: "dd/MM/YYYY h:mm a"}} <small class="unreadMsgCount" *ngIf="data.unreadCount>0">{{data.unreadCount}}</small></div> 
                                    </div><img src="assets/images/down_arrow2.svg">                                    
                                </a>
                                
                              </li>
                              <li *ngIf="allData == 0">
                                <div class="noDataFound">
                                  <h3>No Messages</h3>
                              </div>
                              </li>
                            </ul>
                            </div>
                        </div>
                        <!-- End -->
                    </div>
                   </div>
                   <!--  -->
                   <div class="col-lg-8 hideMob">
                     <div class="bgwhite text-center pd-tb ">
                       <figure class="noDataImage">
                         <img src="assets/images/illus_message.svg " alt="messages">
                       </figure>
                     </div>  
                   </div>
               </div>
        </div> 
        </section>
 </div>




 <!-- End -->



